import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { handlePreferenceSelect } from '../../redux/actions/siteSettingsActions'
import ViewHeader from '../../components/viewHeader/viewHeader';
import PreferencePicker from '../../components/preferencePicker/preferencePicker';
import './preferenceView.scss';

const PreferenceView = ({
  selectedPreference,
  onHandlePreferenceSelect,
  labels,
}) => {
  return (
    <div className="vf-view vf-preference-view">
      <ViewHeader
        header={labels.preferenceViewHeader}
        subHeader={labels.preferenceViewSubHeader}
      />

      <PreferencePicker
        labels={{
          preferenceView_loc: labels.preferenceView_loc,
          preferenceView_temp: labels.preferenceView_temp,
          preferenceView_FT: labels.preferenceView_FT,
          preferenceView_surp: labels.preferenceView_surp,
        }}
        selected={selectedPreference}
        onSelect={onHandlePreferenceSelect}/>
    </div>
  );
};

PreferenceView.propTypes = {
  onHandlePreferenceSelect: PropTypes.func.isRequired,
  selectedPreference: PropTypes.string,
  labels: PropTypes.shape({
    preferenceViewHeader: PropTypes.string.isRequired,
    preferenceViewSubHeader: PropTypes.string.isRequired,
    preferenceView_loc: PropTypes.string.isRequired,
    preferenceView_temp: PropTypes.string.isRequired,
    preferenceView_FT: PropTypes.string.isRequired,
    preferenceView_surp: PropTypes.string.isRequired,
  }).isRequired,
};

PreferenceView.defaultProps = {
  selectedPreference: null,
};

const mapStateToProps = ({ siteSettings, attributeCollection }) => {
  const labels = {
    preferenceViewHeader: attributeCollection.preferenceViewHeader,
    preferenceViewSubHeader: attributeCollection.preferenceViewSubHeader,
    preferenceView_loc: attributeCollection.preferenceView_loc,
    preferenceView_temp: attributeCollection.preferenceView_temp,
    preferenceView_FT: attributeCollection.preferenceView_FT,
    preferenceView_surp: attributeCollection.preferenceView_surp,
  }

  return {
    selectedPreference: siteSettings.filters.selectedPreference,
    routes: siteSettings.routes,
    labels,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onHandlePreferenceSelect: (preference) => {
      dispatch(handlePreferenceSelect(preference));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreferenceView);
